import React, { PureComponent, Fragment } from 'react';
import { Link } from 'formlabs-web-components/Link';
import { Cell } from 'formlabs-web-components/Grid';
import PropTypes from 'prop-types';

import './Footer.module.css';

class FooterMenu extends PureComponent {
  render() {
    const { splitMenu } = this.props;
    return (
      <Fragment>
        {splitMenu.map((menu, i) => {
          return (
            <Cell largeSize={3} key={`footer-mobile-menu-${i}`}>
              {menu.map(menuItem => {
                return (
                  <div
                    styleName="menu-item"
                    key={`${menuItem.url}${menuItem.name}`}
                  >
                    <p>{menuItem.name}</p>
                    {menuItem.children.map(subMenuItem => {
                      return (
                        <div
                          styleName="submenu-item"
                          key={`${subMenuItem.url} ${subMenuItem.name}`}
                        >
                          <Link
                            to={subMenuItem.url}
                            openInNewWindow={subMenuItem.newWindow}
                          >
                            {subMenuItem.name}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </Cell>
          );
        })}
      </Fragment>
    );
  }
}

FooterMenu.propTypes = {
  splitMenu: PropTypes.array
};

export default FooterMenu;
